import authAxios from '../auth/axios';
// import accountAxios from '../account/axios';
import http from '../utils/http';
import User from './user';
import store from '../../store';

export default {

	getUser(){
		return authAxios({ url: 'me', method:'GET' })
			.then(http.resolveData, http.rejectData)
			.then(user => {
				return User.fromDTO(user);
			});
	},
	createAccessKey() {
		return authAxios({ url: 'keys', method: 'POST' })
			.then(http.resolveData, http.rejectData);
	}
};



// WEBPACK FOOTER //
// ./src/modules/user/api.js